import React from 'react';
import { Link, withRouter, useParams } from 'react-router-dom';

// Custom icon components using SVG
const CheckCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#355fb3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </svg>
);

const CrownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 22v-8l-4-8-4 8-4-8-4 8v8z"></path>
    <path d="M2 22h20"></path>
    <path d="M12 6l-2-2 2-2 2 2-2 2Z"></path>
  </svg>
);

const PictureIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <circle cx="8.5" cy="8.5" r="1.5"></circle>
    <polyline points="21 15 16 10 5 21"></polyline>
  </svg>
);

const IdCardIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"></rect>
    <path d="M8 12h8"></path>
    <path d="M8 16h4"></path>
    <circle cx="6" cy="8" r="2"></circle>
  </svg>
);

const LinkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
  </svg>
);

const AppstoreIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7"></rect>
    <rect x="14" y="3" width="7" height="7"></rect>
    <rect x="14" y="14" width="7" height="7"></rect>
    <rect x="3" y="14" width="7" height="7"></rect>
  </svg>
);

const StarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
  </svg>
);

const FireIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"></path>
  </svg>
);

const UserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const EnvironmentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

const ReadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
  </svg>
);

const PlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

const CompassIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>
  </svg>
);

const ApiIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m16 12 2-3-4-3 2 3-2 3 4 3-2-3z"></path>
    <path d="M8 12 6 9l4-3-2 3 2 3-4 3 2-3z"></path>
    <circle cx="12" cy="12" r="10"></circle>
  </svg>
);

const DollarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="1" x2="12" y2="23"></line>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
  </svg>
);

const ClockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

const FileIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>
);

const TrophyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
    <path d="M4 22h16"></path>
    <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
    <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
    <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
  </svg>
);

const CalendarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

// Small chevron component for the collapsible sections
const ChevronIcon = ({ isExpanded }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{
      transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
      transition: 'transform 0.3s ease'
    }}
  >
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);

const SubscriptionCard = ({ title, price, features, popular, trial }) => (
  <div
    style={{
      height: '100%',
      borderRadius: '8px',
      boxShadow: popular ? '0 4px 12px rgba(53, 95, 179, 0.2)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
      borderTop: popular ? '3px solid #355fb3' : 'none',
      position: 'relative',
      overflow: 'visible',
      padding: '24px',
      backgroundColor: 'white',
      marginBottom: '20px',
      transition: 'transform 0.2s ease',
      cursor: 'pointer'
    }}
    onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
    onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
  >
    {popular && (
      <div style={{
        position: 'absolute',
        top: '-12px',
        right: '20px',
        background: '#355fb3',
        color: 'white',
        padding: '2px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
      }}>
        <CrownIcon /> Am Beliebtesten
      </div>
    )}

    <h3 style={{ fontSize: '20px', marginBottom: '8px', color: '#355fb3' }}>
      {title}
    </h3>

    <div style={{
      fontSize: '24px',
      fontWeight: 'bold',
      marginBottom: '16px',
      color: '#333'
    }}>
      €{price}
      <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#666' }}> pro Jahr</span>
      {trial && (
        <div style={{
          marginTop: '4px',
          fontSize: '14px',
          fontWeight: 'normal',
          color: '#52c41a',
         display: 'none',
          alignItems: 'center',
          gap: '4px'
        }}>
          <div style={{  width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#52c41a' }}></div>
          1 Jahr kostenlos testen!
        </div>
      )}
    </div>

    <hr style={{ margin: '12px 0', border: 'none', borderTop: '1px solid #eee' }} />

    <ul style={{
      listStyleType: 'none',
      padding: 0,
      margin: 0,
      fontSize: '14px'
    }}>
      {features.map((feature, index) => (
        <li key={index} style={{
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'flex-start'
        }}>
          <span style={{ marginRight: '8px', marginTop: '3px', color: '#355fb3' }}>
            <CheckCircleIcon />
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ color: '#666' }}>{feature.icon}</span> {feature.text}
          </span>
        </li>
      ))}
    </ul>

    <div style={{ marginTop: '20px' }}>
    <Link to="/admin/plans">
      <button style={{
        width: '100%',
        backgroundColor: '#355fb3',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        padding: '10px 0',
        fontSize: '15px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease'
      }}

      onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2a4b8e'}
      onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#355fb3'}>
        Jetzt Auswählen
      </button></Link>
    </div>
  </div>
);

const SubscriptionSection = ({ title, children }) => {
  const [isExpanded, setIsExpanded] = React.useState(true);

  return (
    <div style={{
      marginBottom: '40px',
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)',
      border: '1px solid #e8e8e8'
    }}>
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '18px 24px',
          backgroundColor: '#355fb3',
          color: 'white'
        }}
      >
        <h2 style={{
          fontSize: '22px',
          color: 'white',
          margin: 0,
          fontWeight: '500'
        }}>
          {title}
        </h2>
        <div style={{
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <ChevronIcon isExpanded={isExpanded} />
        </div>
      </div>

      {isExpanded && (
        <div style={{
          padding: '30px 24px',
          backgroundColor: 'white',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          {children}
        </div>
      )}
    </div>
  );
};

const PmpSubscriptions = () => {
  const herstellerFeatures = {
    classic: [
      { icon: <PictureIcon />, text: '1 Bild / Logo' },
      { icon: <IdCardIcon />, text: 'Herstellername' },
      { icon: <LinkIcon />, text: 'Verlinkung Website' },
      { icon: <AppstoreIcon />, text: '10 Produktprofile' }
    ],
    premium: [
      { icon: <PictureIcon />, text: '1 Bild / Logo + Medien Galerie' },
      { icon: <IdCardIcon />, text: 'Herstellername' },
      { icon: <LinkIcon />, text: 'Verlinkung Website' },
      { icon: <AppstoreIcon />, text: 'Unbegrenzte Produktprofile + Medien Galerie' },
      { icon: <StarIcon />, text: 'Produkte bei Suchanfragen bevorzugt' },
      { icon: <FireIcon />, text: 'Dauerhaft: 1 Produkt bei „Produkte im Fokus" auf der Startseite – kann ausgewählt und geändert werden' }
    ]
  };

  const referentFeatures = {
    classic: [
      { icon: <UserIcon />, text: 'Name, Vorname, Titel' },
      { icon: <PictureIcon />, text: 'Bild' },
      { icon: <EnvironmentIcon />, text: 'PLZ/Ort' },
      { icon: <ReadIcon />, text: 'Grundqualifikation' },
      { icon: <PlusIcon />, text: 'Zusatzqualifikation' }
    ],
    premium: [
      { icon: <UserIcon />, text: 'Name, Vorname, Titel' },
      { icon: <PictureIcon />, text: 'Bild' },
      { icon: <EnvironmentIcon />, text: 'PLZ/Ort' },
      { icon: <ReadIcon />, text: 'Grundqualifikation' },
      { icon: <PlusIcon />, text: 'Zusatzqualifikation' },
      { icon: <CompassIcon />, text: 'Einsatzradius' },
      { icon: <AppstoreIcon />, text: 'Themengebiete' },
      { icon: <ApiIcon />, text: 'ICW-Register Schnittstelle' }
    ],
    premiumPlus: [
      { icon: <UserIcon />, text: 'Name, Vorname, Titel' },
      { icon: <PictureIcon />, text: 'Bild' },
      { icon: <EnvironmentIcon />, text: 'PLZ/Ort' },
      { icon: <ReadIcon />, text: 'Grundqualifikation' },
      { icon: <PlusIcon />, text: 'Zusatzqualifikation' },
      { icon: <CompassIcon />, text: 'Einsatzradius' },
      { icon: <AppstoreIcon />, text: 'Themengebiete' },
      { icon: <ApiIcon />, text: 'ICW-Register Schnittstelle' },
      { icon: <DollarIcon />, text: 'Honorarvorstellung' },
      { icon: <ClockIcon />, text: 'Terminverfügbarkeit (Kalenderfunktion)' },
      { icon: <FireIcon />, text: 'Profilfokussierung' }
    ]
  };

  const versorgungspartnerFeatures = {
    classic: [
      { icon: <AppstoreIcon />, text: 'Eintrag erscheint in der normalen Liste' },
      { icon: <LinkIcon />, text: 'Verlinkung Website' }
    ],
    premium: [
      { icon: <StarIcon />, text: 'Eintrag erscheint in der normalen Liste und auch im Top' },
      { icon: <LinkIcon />, text: 'Verlinkung Website' },
      { icon: <FileIcon />, text: 'Möglichkeit Flyer hochzuladen' },
      { icon: <PictureIcon />, text: 'Bildergalerie' },
      { icon: <TrophyIcon />, text: 'Bei Suchanfragen bevorzugt' }
    ]
  };

  const veranstalterFeatures = {
    classic: [
      { icon: <CalendarIcon />, text: '3 Veranstaltungen' },
      { icon: <AppstoreIcon />, text: 'Erscheinen in der Standardliste' },
      { icon: <LinkIcon />, text: 'Verlinkung Website' }
    ],
    premium: [
      { icon: <CalendarIcon />, text: 'Unbegrenzte Anzahl Veranstaltungen' },
      { icon: <StarIcon />, text: 'Erscheinen in der Standardliste und der Fokusliste' },
      { icon: <LinkIcon />, text: 'Verlinkung Website' },
      { icon: <FileIcon />, text: 'Möglichkeit Flyer hochzuladen' },
      { icon: <PictureIcon />, text: 'Bildergalerie' }
    ]
  };

  return (
    <>
      <div className="city-section-wrapper static-padding">
        <br />
        <div className="subscription-options" style={{ }}>
          <div style={{
          }}>
            <h2
              style={{
                textAlign: 'left', marginBottom: 8
              }}
            >Abonnements</h2>
            <hr
              style={{
                backgroundColor: '#355fb3',
                width: '75px',
                height: '2px',
                border: 'none',
                marginTop: '0px',
                marginLeft: '0px',
                marginBottom: '10px'
              }}
            />
            <p style={{
              color: '#545454',
              fontSize: '15.3px',
              marginTop: '0px',
              textAlign: 'left',
              lineHeight: '20px'
            }}>
              Wählen Sie das passende Abonnement für Ihre Bedürfnisse und nutzen Sie alle Vorteile der PMP-Plattform.
            </p>
          </div>

          <SubscriptionSection title="Hersteller">
            <div style={{ flex: '1 1 calc(50% - 20px)', minWidth: '280px' }}>
              <SubscriptionCard
                title="Hersteller: Classic"
                price="699,90"
                features={herstellerFeatures.classic}
              />
            </div>
            <div style={{ flex: '1 1 calc(50% - 20px)', minWidth: '280px' }}>
              <SubscriptionCard
                title="Hersteller: Premium"
                price="999,90"
                features={herstellerFeatures.premium}
                popular={true}
              />
            </div>
          </SubscriptionSection>

          <SubscriptionSection title="Referent">
            <div style={{ flex: '1 1 calc(33.333% - 20px)', minWidth: '280px' }}>
              <SubscriptionCard
                title="Referent: Classic"
                price="49,99"
                features={referentFeatures.classic}
                trial={true}
              />
            </div>
            <div style={{ flex: '1 1 calc(33.333% - 20px)', minWidth: '280px' }}>
              <SubscriptionCard
                title="Referent: Premium"
                price="79,99"
                features={referentFeatures.premium}
                trial={true}
                popular={true}
              />
            </div>
            <div style={{ flex: '1 1 calc(33.333% - 20px)', minWidth: '280px' }}>
              <SubscriptionCard
                title="Referent: Premium Plus"
                price="99,99"
                features={referentFeatures.premiumPlus}
                trial={true}
              />
            </div>
          </SubscriptionSection>

          <SubscriptionSection title="Versorgungspartner">
            <div style={{ flex: '1 1 calc(50% - 20px)', minWidth: '280px' }}>
              <SubscriptionCard
                title="Versorgungspartner: Classic"
                price="79,99"
                features={versorgungspartnerFeatures.classic}
                trial={true}
              />
            </div>
            <div style={{ flex: '1 1 calc(50% - 20px)', minWidth: '280px' }}>
              <SubscriptionCard
                title="Versorgungspartner: Premium"
                price="99,99"
                features={versorgungspartnerFeatures.premium}
                popular={true}
                trial={true}
              />
            </div>
          </SubscriptionSection>

          <SubscriptionSection title="Veranstalter">
            <div style={{ flex: '1 1 calc(50% - 20px)', minWidth: '280px' }}>
              <SubscriptionCard
                title="Veranstalter: Classic"
                price="99,99"
                features={veranstalterFeatures.classic}
                trial={true}
              />
            </div>
            <div style={{ flex: '1 1 calc(50% - 20px)', minWidth: '280px' }}>
              <SubscriptionCard
                title="Veranstalter: Premium"
                price="199,99"
                features={veranstalterFeatures.premium}
                popular={true}
                trial={true}
              />
            </div>
          </SubscriptionSection>
        </div>
      </div>
    </>
  );
};

export default PmpSubscriptions;